export default __webpack_public_path__ + "static/media/harvel-social-icon.9e88cfe1.jpg";